import { render, staticRenderFns } from "./lobby.vue?vue&type=template&id=4bd3f900&scoped=true&"
import script from "./lobby.ts?vue&type=script&lang=ts&"
export * from "./lobby.ts?vue&type=script&lang=ts&"
import style0 from "./lobby.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./lobby.vue?vue&type=style&index=1&id=4bd3f900&lang=stylus&scoped=true&"
import style2 from "./lobby.vue?vue&type=style&index=2&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd3f900",
  null
  
)

export default component.exports